var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-start align-center mt-1"},[_c('BaseActionsButton',{attrs:{"id":"detailsRouteQuotation","name":"detailsRouteQuotation","iconName":"mdi-eye","iconColor":"primary","customClass":"mr-2","tooltipMessage":"View Details"},on:{"click":function($event){return _vm.viewRouteQuotationDetails()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }